import { HttpClient } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { InAppPurchase2, IAPQueryCallback, IAPProduct } from '@ionic-native/in-app-purchase-2';
import { Platform, AlertController } from 'ionic-angular';
import { Constants } from '../../util/Constants';
import { TranslateService } from '@ngx-translate/core';
import { WebSocketService } from '../../services/webSocketService';
import { APP_ID_RANDOM_PROVIDER } from '@angular/core/src/application_tokens';

/*
  Generated class for the KintipsInAppPurchaseProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/

declare var storekit: any;

export declare type KintipsIAPListener = (eventType: IAP_EVENT, data: any) => void;

export enum IAP_EVENT { APPROVED, VERIFYING, VERIFIED, UNVERIFIED, ERROR, UPDATED };

@Injectable()
export class KintipsInAppPurchaseProvider implements OnDestroy{

  approvedCallback: IAPQueryCallback;
  verifyCb: any;
  verifiedCb: any;
  unverifiedCb: any;
  updatedCb: any;

  iapStatusListeners: Array<KintipsIAPListener> = new Array<KintipsIAPListener>();


  constructor(private iap: InAppPurchase2, private platform: Platform, private translateService: TranslateService, private webSocketService: WebSocketService,
    private alertCtrl: AlertController) {
    console.log('Hello KintipsInAppPurchaseProvider Provider');

  }

  addListener(listener: KintipsIAPListener) {
    this.iapStatusListeners.push(listener);
  }

  removeListener(listener: KintipsIAPListener) {
    for( var i = 0; i < this.iapStatusListeners.length; i++){
      if ( this.iapStatusListeners[i] === listener) {
        this.iapStatusListeners.splice(i, 1);
        i--;
      }
    }
  }

  boardcastToListener(eventType: IAP_EVENT, data: any) {
    for (var i = 0; i < this.iapStatusListeners.length; i++) {
      this.iapStatusListeners[i](eventType, data);
    }
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.iap.off(this.approvedCallback);
    this.iap.off(this.verifyCb);
    this.iap.off(this.verifiedCb);
    this.iap.off(this.unverifiedCb);
    this.iap.off(this.updatedCb);
  }

  public init() {
    this.approvedCallback = (product: IAPProduct) => {
      this.boardcastToListener(IAP_EVENT.APPROVED, product);
      product.verify();
    }

    this.verifyCb = (product: IAPProduct, callback: Function) => {
      this.boardcastToListener(IAP_EVENT.VERIFYING, product);
      if (this.platform.is("ios")) {
        this.requestInAppPurchase(product.transaction.appStoreReceipt, product, Constants.APPLE_IN_APP_PURCHASE_METHOD).then(() => {
          callback(true, {product: product});
        }).catch(err => {
          console.log("requestInAppPurchase failed");
          console.log(err);
          callback(false, {product: product});
        });
      } else if (this.platform.is("android")) {
        this.requestInAppPurchase(product.transaction.purchaseToken, product, Constants.GOOGLE_PLAY_IN_APP_PURCHASE_METHOD).then(() => {
          callback(true, {product: product});
        }).catch(err => {
          console.log("requestInAppPurchase failed");
          console.log(err);
          callback(false, {product: product});
        });
      }
    };

    this.iap.validator = this.verifyCb;

    this.verifiedCb = (product) => {
      product.finish();
      if (this.platform.is("ios")) {
        if ( window.localStorage && window.localStorage.sk_appStoreReceipt ) {
          window.localStorage.sk_appStoreReceipt = null;
        }
        if (storekit.appStoreReceipt ) {
          storekit.appStoreReceipt = null;
        }
      }
      this.boardcastToListener(IAP_EVENT.VERIFIED, product);
    }

    this.unverifiedCb = (product) => {
      if (this.platform.is("ios")) {
        if ( window.localStorage && window.localStorage.sk_appStoreReceipt ) {
          window.localStorage.sk_appStoreReceipt = null;
        }
        if (storekit.appStoreReceipt ) {
          storekit.appStoreReceipt = null;
        }
      }

      this.boardcastToListener(IAP_EVENT.UNVERIFIED, product);
    }

    this.updatedCb = (product) => {
      this.boardcastToListener(IAP_EVENT.UPDATED, product);
    }

    if (this.platform.is("android")) {
      this.iap.register({
        id: 'com.kintips.kintips.and.coin100',
        alias: 'coin100',
        type: this.iap.CONSUMABLE
      });

      this.iap.register({
        id: 'com.kintips.kintips.and.coin200',
        alias: 'coin200',
        type: this.iap.CONSUMABLE
      });

      this.iap.register({
        id: 'com.kintips.kintips.and.coin300',
        alias: 'coin300',
        type: this.iap.CONSUMABLE
      });

      this.iap.register({
        id: 'com.kintips.kintips.and.coin400',
        alias: 'coin400',
        type: this.iap.CONSUMABLE
      });

      this.iap.register({
        id: 'com.kintips.kintips.and.coin500',
        alias: 'coin500',
        type: this.iap.CONSUMABLE
      });

      this.iap.register({
        id: 'com.kintips.kintips.and.guestprice1',
        alias: 'guestPrice1',
        type: this.iap.CONSUMABLE
      });

      this.iap.register({
        id: 'com.kintips.kintips.and.guestprice2',
        alias: 'guestPrice2',
        type: this.iap.CONSUMABLE
      });

      this.iap.register({
        id: 'com.kintips.kintips.and.guestprice3',
        alias: 'guestPrice3',
        type: this.iap.CONSUMABLE
      });

      this.iap.register({
        id: 'com.kintips.kintips.and.guestprice4',
        alias: 'guestPrice4',
        type: this.iap.CONSUMABLE
      });

      this.iap.register({
        id: 'com.kintips.kintips.and.guestpackageprice1',
        alias: 'guestPackagePrice1',
        type: this.iap.CONSUMABLE
      });

      this.iap.register({
        id: 'com.kintips.kintips.and.guestpackageprice2',
        alias: 'guestPackagePrice2',
        type: this.iap.CONSUMABLE
      });

      this.iap.register({
        id: 'com.kintips.kintips.and.guestpackageprice3',
        alias: 'guestPackagePrice3',
        type: this.iap.CONSUMABLE
      });

      this.iap.register({
        id: 'com.kintips.kintips.and.guestpackageprice4',
        alias: 'guestPackagePrice4',
        type: this.iap.CONSUMABLE
      });

      this.iap.register({
        id: 'com.kintips.kintips.and.guestpackageprice5',
        alias: 'guestPackagePrice5',
        type: this.iap.CONSUMABLE
      });

      this.iap.register({
        id: 'com.kintips.kintips.and.guestpackageprice6',
        alias: 'guestPackagePrice6',
        type: this.iap.CONSUMABLE
      });

      this.iap.register({
        id: 'com.kintips.kintips.and.guestpackageprice7',
        alias: 'guestPackagePrice7',
        type: this.iap.CONSUMABLE
      });

      this.iap.register({
        id: 'com.kintips.kintips.and.guestpackageprice8',
        alias: 'guestPackagePrice8',
        type: this.iap.CONSUMABLE
      });

      this.iap.register({
        id: 'com.kintips.kintips.and.guestpackageprice9',
        alias: 'guestPackagePrice9',
        type: this.iap.CONSUMABLE
      });

      this.iap.register({
        id: 'com.kintips.kintips.and.guestpackageprice10',
        alias: 'guestPackagePrice10',
        type: this.iap.CONSUMABLE
      });
    } else if (this.platform.is("ios")) {
      this.iap.register({
        id: 'com.kintips.kintips.ios.coin100',
        alias: 'coin100',
        type: this.iap.CONSUMABLE
      });

      this.iap.register({
        id: 'com.kintips.kintips.ios.coin200',
        alias: 'coin200',
        type: this.iap.CONSUMABLE
      });

      this.iap.register({
        id: 'com.kintips.kintips.ios.coin300',
        alias: 'coin300',
        type: this.iap.CONSUMABLE
      });

      this.iap.register({
        id: 'com.kintips.kintips.ios.coin400',
        alias: 'coin400',
        type: this.iap.CONSUMABLE
      });

      this.iap.register({
        id: 'com.kintips.kintips.ios.coin500',
        alias: 'coin500',
        type: this.iap.CONSUMABLE
      });

      this.iap.register({
        id: 'com.kintips.kintips.ios.guestprice1',
        alias: 'guestPrice1',
        type: this.iap.CONSUMABLE
      });

      this.iap.register({
        id: 'com.kintips.kintips.ios.guestprice2',
        alias: 'guestPrice2',
        type: this.iap.CONSUMABLE
      });

      this.iap.register({
        id: 'com.kintips.kintips.ios.guestprice3',
        alias: 'guestPrice3',
        type: this.iap.CONSUMABLE
      });

      this.iap.register({
        id: 'com.kintips.kintips.ios.guestprice4',
        alias: 'guestPrice4',
        type: this.iap.CONSUMABLE
      });

      this.iap.register({
        id: 'com.kintips.kintips.ios.guestpackageprice1',
        alias: 'guestPackagePrice1',
        type: this.iap.CONSUMABLE
      });

      this.iap.register({
        id: 'com.kintips.kintips.ios.guestpackageprice2',
        alias: 'guestPackagePrice2',
        type: this.iap.CONSUMABLE
      });

      this.iap.register({
        id: 'com.kintips.kintips.ios.guestpackageprice3',
        alias: 'guestPackagePrice3',
        type: this.iap.CONSUMABLE
      });

      this.iap.register({
        id: 'com.kintips.kintips.ios.guestpackageprice4',
        alias: 'guestPackagePrice4',
        type: this.iap.CONSUMABLE
      });

      this.iap.register({
        id: 'com.kintips.kintips.ios.guestpackageprice5',
        alias: 'guestPackagePrice5',
        type: this.iap.CONSUMABLE
      });

      this.iap.register({
        id: 'com.kintips.kintips.ios.guestpackageprice6',
        alias: 'guestPackagePrice6',
        type: this.iap.CONSUMABLE
      });

      this.iap.register({
        id: 'com.kintips.kintips.ios.guestpackageprice7',
        alias: 'guestPackagePrice7',
        type: this.iap.CONSUMABLE
      });

      this.iap.register({
        id: 'com.kintips.kintips.ios.guestpackageprice8',
        alias: 'guestPackagePrice8',
        type: this.iap.CONSUMABLE
      });

      this.iap.register({
        id: 'com.kintips.kintips.ios.guestpackageprice9',
        alias: 'guestPackagePrice9',
        type: this.iap.CONSUMABLE
      });

      this.iap.register({
        id: 'com.kintips.kintips.ios.guestpackageprice10',
        alias: 'guestPackagePrice10',
        type: this.iap.CONSUMABLE
      });
    }

    this.iap.verbosity = this.iap.INFO;
    this.iap.when("consumable order").approved(this.approvedCallback);
    this.iap.when("consumable order").verified(this.verifiedCb);
    this.iap.when("consumable order").unverified(this.unverifiedCb);
    this.iap.when("consumable order").updated(this.updatedCb);

    this.iap.error((err,b) => {
      console.log("error");
      console.log(err);
      this.boardcastToListener(IAP_EVENT.ERROR, {msg: "IAP error"});
    });


    this.iap.refresh();
  }

  requestInAppPurchase(purchaseToken, product, method): Promise<any> {
    return new Promise((resolve, reject) => {
      this.webSocketService.requestInAppPurchase(purchaseToken, product.id, method).then(msg => {
        purchaseToken = null;
        resolve();
      }, err => {
        let errorCode = err.code;
        if (errorCode == "100021") {
          console.log("100021");
          console.log(err);
          resolve();
          // product.finish();
        } else {
          console.log("non10021Error");
          console.log(err);
          reject();
        }

      });
    });
  }

  public refresh() {
    this.iap.refresh();
  }

  public order(productAlias: string): {
    then: Function;
    error: Function;
  } {
    if (this.platform.is("ios")) {
      if ( window.localStorage && window.localStorage.sk_appStoreReceipt ) {
        window.localStorage.sk_appStoreReceipt = null;
      }
      if (storekit.appStoreReceipt ) {
        storekit.appStoreReceipt = null;
      }
    }
    let productState = this.iap.get(productAlias).state;
    if (this.iap.get(productAlias).state == "valid") {
      return this.iap.order(productAlias);
    } else {
      throw new Error("Cannot buy " + productAlias  + ". State: " + productState);
    }
  }
}



// WEBPACK FOOTER //
// ./src/providers/kintips-in-app-purchase/kintips-in-app-purchase.ts